<!-- Step 2: Upload Files -->
<div class="step-upload-files">
  <h2 class="step-title">Upload Files</h2>
  <p class="step-description">
    Upload your CheckPrint files. You can drag and drop files or use the file
    picker.
  </p>

  <!-- File Drop Zone -->
  <section class="upload-section">
    <app-file-drop-zone
      (filesUploaded)="onFilesUploaded()"></app-file-drop-zone>
  </section>

  <!-- Uploaded Files Grid -->
  <section class="grid-section">
    <app-uploaded-files-grid
      (fileRemoved)="onFileRemoved()"></app-uploaded-files-grid>
  </section>
</div>
